import { useState, useCallback } from 'react'
import { SCROLL_BEHAVIOR_CONFIG } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/constants'
import type {
  UseGiveawayTabsReturn,
  TabData,
} from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/types'
import { GiveawayTabEnum } from '@/views/PreSales/PreSalesGiveawayView/config'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'
import { useTabMappings } from './useTabMappings'

export const useGiveawayTabs = (): UseGiveawayTabsReturn => {
  const {
    selectedIndex,
    setSelectedIndex,
    isActive,
    tickets,
    entryVariantId,
    giveawayData: { tabs },
    tabsContainerRef,
    desktopTicketContainerRef,
    detailsContainerRef,
    faqContainerRef,
    prizesContainerRef,
    theatricalSlug,
  } = useGiveawayContext()

  const [activeTab] = useState<GiveawayTabEnum | null>(null)

  const { refs } = useTabMappings({ detailsContainerRef, faqContainerRef, prizesContainerRef })

  const handleTabChange = useCallback(
    (index: number) => {
      setSelectedIndex(index)
      tabsContainerRef.current?.scrollIntoView(SCROLL_BEHAVIOR_CONFIG)
    },
    [setSelectedIndex, tabsContainerRef],
  )

  const shouldShowTicketSection = !!(isActive && tickets && entryVariantId)

  return {
    tabs: tabs as TabData[],
    activeTab,
    selectedIndex,
    handleTabChange,
    isActive,
    tabsContainerRef,
    desktopTicketContainerRef,
    shouldShowTicketSection,
    refs,
    tickets,
    entryVariantId,
    theatricalSlug,
  }
}
